// import arrOptions from 'shared/constant/arrOptions';
import { getUserPayLoad, applicantAction } from 'shared/store/actions';
import apiRequest from 'shared/services/api';
import withRetry from 'shared/helpers/withRetry';
import { PDF_TYPE, INVESTMENT_STRATEGY } from 'shared/constant';
import { ACTION_TYPE } from './actionTypes';

const { AGREEMENTS, APPLICANT } = ACTION_TYPE;
// const { agreementAofKycOptions } = arrOptions;

/**
 * GET Qualified Applicant's Agreement status
 */
const getQualifiedAgreementStatus = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
  } = getState();
  const isAgreementReady = await apiRequest.getQualifiedAgreementStatus(token, phoneNumber);
  await dispatch({
    type: AGREEMENTS.IS_AGREEMENT_READY_FOR_QUALIFIED,
    isAgreementReadyForQualified: isAgreementReady,
  });
};

const updateAofKyc = selectedId => (dispatch, getState) => {
  const { selected, agreements } = getState().agreementReducer.aofKyc;

  let arrOfSelectedOptions;
  const arrOfAgreements = [...agreements];
  let newAgreements;

  if (selected.includes(selectedId)) {
    arrOfSelectedOptions = selected.filter(item => item !== selectedId);
    newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: arrOfSelectedOptions.includes(item.id),
    }));
  } else {
    arrOfSelectedOptions = [...selected.filter(item => item !== selectedId), selectedId];
    // newAgreements = arrOfAgreements;
    newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: selectedId === item.id || selected.includes(item.id),
    }));
  }

  const newAofKyc = {
    selected: arrOfSelectedOptions,
    agreements: newAgreements,
  };


  dispatch({
    type: AGREEMENTS.UPDATE_AOF_KYC,
    payload: newAofKyc,
  });
};

const updateProfileAgreement = selectedId => (dispatch, getState) => {
  const { selected, agreements } = getState().agreementReducer.profile;

  let arrOfSelectedOptions;
  const arrOfAgreements = [...agreements];
  let newAgreements;

  if (selected.includes(selectedId)) {
    arrOfSelectedOptions = selected.filter(item => item !== selectedId);
    newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: arrOfSelectedOptions.includes(item.id),
    }));
  } else {
    arrOfSelectedOptions = [...selected.filter(item => item !== selectedId), selectedId];
    newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: selectedId === item.id || selected.includes(item.id),
    }));
  }

  const newProfile = {
    selected: arrOfSelectedOptions,
    agreements: newAgreements,
  };


  dispatch({
    type: AGREEMENTS.UPDATE_PROFILE,
    payload: newProfile,
  });
};

/**
 * Save on the store Fetched agreements
 * @param {*} obj
 */
const fetchAgreements = obj => async (dispatch, getState) => {
  const { agreementReducer } = getState();

  const parsedAofKyc = () => {
    const { aofKyc: { agreements } } = agreementReducer;
    const { aofKyc } = obj;
    const arrOfAgreements = [...agreements];
    const newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: Boolean(aofKyc.filter(x => x.id === item.id).map(y => y.isChecked).toString()),
    }));

    const newSelectedArr = aofKyc.filter(item => item.isChecked).map(x => x.id);

    const newAofKycAgreements = {
      selected: newSelectedArr,
      agreements: newAgreements,
    };

    return newAofKycAgreements;
  };

  const parsedProfile = () => {
    const { profile: { agreements } } = agreementReducer;
    const { profile } = obj;
    const arrOfAgreements = [...agreements];
    const newAgreements = arrOfAgreements.map(item => ({
      ...item,
      isChecked: Boolean(profile.filter(x => x.id === item.id).map(y => y.isChecked).toString()),
    }));

    const newSelectedArr = profile.filter(item => item.isChecked).map(x => x.id);

    const newProfileAgreements = {
      selected: newSelectedArr,
      agreements: newAgreements,
    };

    return newProfileAgreements;
  };

  const newData = {
    ...agreementReducer,
    aofKyc: parsedAofKyc(),
    profile: parsedProfile(),
    aofKycProfileSignature: obj.aofKycProfileSignature,
    ndpf: obj.ndpf,
    proposedPlan: obj.proposedPlan,
    ndpfProposedPlanSignature: obj.ndpfProposedPlanSignature,
    aofKycProfileTimestamp: obj.aofKycProfileTimestamp,
    ndpfProposedPlanTimestamp: obj.ndpfProposedPlanTimestamp,
  };

  dispatch({
    type: AGREEMENTS.FETCH_AGREEMENTS,
    payload: newData,
  });
};

const toggleAcknowledgementUndertaking = () => ({
  type: AGREEMENTS.ACKNOWLEDGEMENT_UNDERTAKING,
});

const toggleProposedPlan = () => ({
  type: AGREEMENTS.PROPOPOSED_PLAN,
});

/**
 * Update signature (value is base64)
 * @param {*} name
 * @param {*} value
 */
const updateSignature = (name, value) => ({
  type: AGREEMENTS.SIGNATURE,
  payload: { name, value },
});

const updateAofKycProfileTimestamp = (aofKycProfileTimestamp, aofKycProfileTimestampUTC) => ({
  type: AGREEMENTS.TIMESTAMP_AOFKYC_PROFILE,
  payload: { aofKycProfileTimestamp, aofKycProfileTimestampUTC },
});

const updateNdpfProposedPlanTimestamp = (ndpfProposedPlanTimestamp, ndpfProposedPlanTimestampUTC) => ({
  type: AGREEMENTS.TIMESTAMP_NDPF_PROPOSED_PLAN,
  payload: { ndpfProposedPlanTimestamp, ndpfProposedPlanTimestampUTC },
});

const loadProposedAllocationPlan = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
  } = getState();
  const data = getUserPayLoad(getState);

  try {
    const rs = await apiRequest.getPdfByPage(token, data, 29, 29, phoneNumber, PDF_TYPE.APPENDIX_1_PROPOSED_ALLOCATION);

    dispatch({
      type: APPLICANT.APPLICANT_ALLOCATION_PDF,
      payload: rs,
    });
  } catch (e) {
    console.log(e);
  }
};

/** Mutual Fund Subscription (Current working for Retail Applicant) */
const loadSubcription = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    languageReducer: {
      language: { locale },
    },
  } = getState();

  try {
    const rs = await withRetry(() => apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.MUTUAL_FUND_SUBSCRIPTION, locale));
    dispatch({
      type: APPLICANT.APPLICANT_MFT_PDF,
      payload: rs,
    });
  } catch (e) {
    console.log(e);
  }
};

const getInternationRealEstateProductsPDF = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
  } = getState();
  const data = getUserPayLoad(getState);

  try {
    const res = await apiRequest.getPdfByPage(token, data, 23, 26, phoneNumber, PDF_TYPE.APPENDIX_1_PROPOSED_ALLOCATION, 'sub-agreement');

    dispatch({
      type: APPLICANT.APPLICANT_IREP_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(applicantAction.getPdfFail(err));
  }
};

/**
 * GET Non Discretionary Asset Allocation PDF
 */
const getAssetAllocationPDF = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    languageReducer: {
      language: { locale },
    },
  } = getState();
  try {
    const res = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.NON_DISCRETIONARY_ASSET_ALLOCATION, locale);
    dispatch({
      type: APPLICANT.APPLICANT_ASSET_ALLOCATION_PDF,
      payload: res,
    });
  } catch (err) {
    dispatch(applicantAction.getPdfFail(err));
  }
};

/** Only Invoke this on the Final Documentation */
const generateDPFContract = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    languageReducer: {
      language: { locale },
    },
  } = getState();
  try {
    const mainAgreementRes = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.INVESTMENT_AGREEMENT_DPF, locale);
    await dispatch({
      type: APPLICANT.APPLICANT_DPF_PDF,
      payload: mainAgreementRes,
    });
  } catch (err) {
    dispatch(applicantAction.getPdfFail(err));
  }
};

// const getDividendYieldPDF = () => async (dispatch, getState) => {
//   const {
//     authReducer: { token, phoneNumber },
//   } = getState();

//   try {
//     const rs = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.DIVIDEND_YIELD);
//     dispatch({
//       type: APPLICANT.DIVIDEND_YIELD,
//       payload: rs,
//     });
//   } catch (e) {
//     console.log(e);
//   }
// };

/** Generate Custody or CPF Main Agreement  */
const generateCustodyContract = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    languageReducer: {
      language: { locale },
    },
  } = getState();
  try {
    const mainAgreementRes = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.CUSTODY, locale);
    await dispatch({
      type: APPLICANT.APPLICANT_CPF_PDF,
      payload: mainAgreementRes,
    });
  } catch (err) {
    dispatch(applicantAction.getPdfFail(err));
  }
};

/**
 * GET Discretionary Investment Strategy PDFs
 */
const getInvestmentStategyPDFs = () => async (dispatch, getState) => {
  const {
    authReducer: { token, phoneNumber },
    languageReducer: {
      language: { locale },
    },
    applicantRootReducer: {
      personalInformationReducer: {
        clientDetails: { investmentStrategies },
      },
    },
  } = getState();
  const data = getUserPayLoad(getState);
  const isMenaAbsolute = investmentStrategies.includes(INVESTMENT_STRATEGY.MENA_EQUITIES_ABSOLUTE);
  const isMenaAbsoluteSharia = investmentStrategies.includes(INVESTMENT_STRATEGY.MENA_EQUITIES_ABSOLUTE_SHARIA);
  const isDividendYield = investmentStrategies.includes(INVESTMENT_STRATEGY.DIVIDEND_YIELD);
  try {
    let res1;
    let res2;
    let res3;

    /** Main Agreement (DPF) */
    const mainAgreementRes = await apiRequest.getPdfByPage(token, data, 1, 22, phoneNumber, 'markaz-dpf', locale); // await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.INVESTMENT_AGREEMENT_DPF);
    await dispatch({
      type: APPLICANT.APPLICANT_DPF_PDF,
      payload: mainAgreementRes,
    });

    /** Sub Portfolio */
    if (isMenaAbsolute) {
      res1 = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.DISCRETIONARY_MENA_ABSOLUTE, locale);
      await dispatch({
        type: APPLICANT.APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_PDF,
        payload: res1,
      });
    }

    /** Sub Portfolio Sharia */
    if (isMenaAbsoluteSharia) {
      res2 = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.DISCRETIONARY_MENA_SHARIA, locale);
      await dispatch({
        type: APPLICANT.APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_SHARIA_PDF,
        payload: res2,
      });
    }

    /** Sub Portfolio Sharia */
    if (isDividendYield) {
      res3 = await apiRequest.getOtherPDF(phoneNumber, token, PDF_TYPE.DIVIDEND_YIELD, locale);
      await dispatch({
        type: APPLICANT.APPLICANT_DIVIDEND_YIELD,
        payload: res3,
      });
    }
  } catch (err) {
    dispatch(applicantAction.getPdfFail(err));
  }
};

/** Save in the store if custom Asset allocation is uploaded */
const saveIsCustomAAUploaded = payload => ({
  type: AGREEMENTS.IS_CUSTOM_AA_UPLOADED,
  payload,
});

const agreementAction = {
  updateAofKyc,
  updateProfileAgreement,

  toggleAcknowledgementUndertaking,
  toggleProposedPlan,
  updateSignature,

  fetchAgreements,
  updateAofKycProfileTimestamp,
  updateNdpfProposedPlanTimestamp,
  loadProposedAllocationPlan,
  loadSubcription,
  generateDPFContract,

  getQualifiedAgreementStatus,

  getAssetAllocationPDF,
  getInvestmentStategyPDFs,
  getInternationRealEstateProductsPDF,

  generateCustodyContract,
  // getDividendYieldPDF,

  saveIsCustomAAUploaded,
};

export default agreementAction;
